<template>
    <div class="content">

        <div class="downloadBtns">
            <!-- @click='' -->
            <div class="icon_ios" @click="iosDownload">
                <img src="../assets/images/ios.png" width='20' alt="">
                <span>iOS版下载</span>
            </div>
            <div class="icon_android">
                <img src="../assets/images/android.png" width='20' alt="">
                <a @click="androidDownload">android版下载</a>
            </div>
        </div>

        <div class="wxTips" v-if='wxTips' @click="hideWx">
            <div>
                <img src="../assets/images/wxArrow.png" alt="">
                <span>在浏览器中打开</span>
            </div>
        </div>

        <el-dialog center title='app下载' :visible.sync="isDownload" class="download" width="400px" :show-close='false'>
            <div class="code">
                <img src="../assets/images/alipay.png" v-if='iosAndroid == 0' width='200' alt="">
                <a href="https://api.hnlpa.cn/download">
                    <img src="../assets/images/chrome.png" v-if='iosAndroid == 1' width='200' alt="">
                </a>
            </div>
            <el-button type="primary" @click="isDownload = false" class="confirmBtn">确 定</el-button>
            <!-- <el-row class="footer-but">
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark sure" @click="sure">确定</div>
                </el-col>
            </el-row> -->
        </el-dialog>
    </div>

</template>

<script>
export default {
    name: "index",
    components: {

    },
    data () {
        return {
            isDownload: false,
            iosAndroid: 0,
            wxTips: false
        };
    },
    created () {

    },
    mounted () {

        document.getElementsByTagName('body')[0].style.minWidth = 'auto'
        // this.getDownloadUrl();
    },
    beforeDestroy () {
        document.getElementsByTagName('body')[0].style.minWidth = '1200px'
    },
    methods: {
        /**
         * 获取下载地址
         */
        getDownloadUrl () {
            this.$store.dispatch('download', {}).then((res) => {
                if (res.code == 200) {

                }
            }).catch(error => {
                console.error('错误信息：', error)
            })
        },
        /**
         * ios下载提示
         */
        iosDownload () {
            window.location.href = 'https://itunes.apple.com/cn/app/xiang-yao-shi-xie/id1440363754?mt=8';
            // this.$message({
            //     type: 'error',
            //     message: '正在审核中'
            // })
            //   this.iosAndroid = 0;
            // this.isDownload = true;
            //   window.open('https://itunes.apple.com/cn/app//id1027777489?mt=8', '_blank').location
        },
        /**
         * android下载
         */
        androidDownload () {
            // this.iosAndroid = 1;
            // this.isDownload = true;

            //   window.location.href="https://img.baitongshiji.com/apk/btsj-btyx-apk/Pro1_BNX-official-6.2.5-release.apk"

            if( this.isWeiXin() ){
                this.wxTips = true;
            }else{
                window.location.href = 'https://api.hnlpa.cn/download'
            }
        },
        /**
         * 关闭微信浏览器提示
         */
        hideWx(){
            this.wxTips = false;
        },
        /**
         * 判断浏览器
         */
        isWeiXin () {
            var ua = window.navigator.userAgent.toLowerCase();
            // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
            if (ua.indexOf('micromessenger') > -1) {
                return true; // 是微信端
            } else {
                return false;
            }
        },


    }
};
</script>

<style lang="stylus">
.download .el-dialog
    border-radius 8px !important
</style>
<style scoped lang="stylus">
.code
    text-align center
.confirmBtn
    margin 20px auto 0
    display block
    background-image $btnBg
    background-size 100% 100%
    border 0
.content
    height 100vh
    background url('../assets/images/downloadApp_bg.jpg') no-repeat top center #00a5ff
    background-size cover
    min-width 320px
.wxTips
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.6)
    position fixed
    top 0
    left 0
    div 
        position fixed
        right 0
        top 0
        img 
            width 200px
            margin 20px
        span 
            color #fff
            display block
.downloadBtns
    text-align center
    margin auto
    position absolute
    bottom 50px
    left 0
    right 0
    // left 50%
    // transform translateX(-50%)
    width 100%
    div
        display inline-block
        width 230px
        height 52px
        text-align center
        line-height 52px
        color #0173FF
        font-size 16px
        cursor pointer
        margin 15px 40px
        letter-spacing 1px
    a
        display inline-block
        vertical-align middle
    span
        display inline-block
        vertical-align middle
    img
        vertical-align middle
    .icon_ios
        background-image url('../assets/images/icon_ios.png')
        background-size 100% 100%
        color #fff
        a
            color #fff
    .icon_android
        background-image url('../assets/images/icon_android.png')
        background-size 100% 100%
        a
            color #0173ff
</style>




// WEBPACK FOOTER //
// src/components/downloadApp.vue